/** @type {import('./$types').ParamMatcher} */
export function match(param: string): boolean {
  // check the param is valid UUID, if not it will be an false and
  // Automatically redirect to 403 error
  return !!param && new RegExp('^[a-z,0-9,-]{36,36}$', 'g').test(param);
}
